import './style.css'

// Navigation smooth scroll et état actif
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    
    // Retirer la classe active de tous les liens
    document.querySelectorAll('.nav-link').forEach(link => {
      link.classList.remove('active');
    });
    
    // Ajouter la classe active au lien cliqué
    this.classList.add('active');
    
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// Header scroll effect
window.addEventListener('scroll', () => {
  const header = document.querySelector('.header');
  if (window.scrollY > 100) {
    header.style.background = 'rgba(10, 15, 28, 0.98)';
  } else {
    header.style.background = 'rgba(10, 15, 28, 0.95)';
  }
  
  // Mise à jour automatique de l'état actif selon la section visible
  updateActiveNavLink();
});

// Fonction pour mettre à jour le lien actif selon la section visible
function updateActiveNavLink() {
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.nav-link');
  
  let currentSection = '';
  
  sections.forEach(section => {
    const sectionTop = section.offsetTop - 100;
    const sectionHeight = section.offsetHeight;
    
    if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
      currentSection = section.getAttribute('id');
    }
  });
  
  // Mettre à jour les classes actives
  navLinks.forEach(link => {
    link.classList.remove('active');
    if (link.getAttribute('href') === `#${currentSection}`) {
      link.classList.add('active');
    }
  });
}

// Initialiser l'état actif au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  updateActiveNavLink();
});

// Contact form handling - Serveur local sans service externe
document.querySelector('.contact-form form').addEventListener('submit', async function(e) {
  e.preventDefault();
  
  // Get form data
  const nom = this.querySelector('input[name="nom"]').value || '';
  const email = this.querySelector('input[name="email"]').value || '';
  const typeContact = this.querySelector('select[name="typeContact"]').value || '';
  const entrepriseSpecialite = this.querySelector('input[name="entrepriseSpecialite"]').value || '';
  const message = this.querySelector('textarea[name="message"]').value || '';
  
  // Visual feedback
  const button = this.querySelector('button');
  const originalText = button.textContent;
  button.textContent = 'Envoi en cours...';
  button.disabled = true;
  button.style.background = 'linear-gradient(135deg, #ff9500, #ff6b00)';
  
  try {
    // Envoi via notre serveur local
    const response = await fetch('http://localhost:3001/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        nom,
        email,
        typeContact,
        entrepriseSpecialite,
        message
      })
    });
    
    const result = await response.json();
    
    if (result.success) {
      // Succès
      button.textContent = 'Message envoyé !';
      button.style.background = 'linear-gradient(135deg, #28a745, #20c997)';
      
      // Reset du formulaire après succès
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.style.background = 'linear-gradient(135deg, #4a9eff, #0066cc)';
        this.reset();
      }, 3000);
      
    } else {
      throw new Error(result.error || 'Erreur lors de l\'envoi');
    }
    
  } catch (error) {
    console.error('Erreur:', error);
    
    // Fallback vers mailto si le serveur local ne répond pas
    button.textContent = 'Serveur indisponible - Fallback...';
    button.style.background = 'linear-gradient(135deg, #ffc107, #ff8800)';
    
    setTimeout(() => {
      // Fallback mailto
      const typeLabel = typeContact === 'entreprise' ? 'Entreprise' : typeContact === 'profil' ? 'Profil technique' : 'Non spécifié';
      const subject = `Contact depuis Velora Intelligence - ${nom}`;
      const body = `Nom: ${nom}
Email: ${email}
Type de contact: ${typeLabel}
${typeContact === 'entreprise' ? 'Entreprise' : 'Spécialité'}: ${entrepriseSpecialite}

Message:
${message}

---
Envoyé depuis velora-intelligence.com (serveur local indisponible)`;
      
      const mailtoLink = `mailto:alouioussema@hotmail.fr?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;
      
      button.textContent = 'Client email ouvert !';
      button.style.background = 'linear-gradient(135deg, #007bff, #0056b3)';
      
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.style.background = 'linear-gradient(135deg, #4a9eff, #0066cc)';
      }, 3000);
    }, 1000);
  }
});

// Add animation on scroll
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, observerOptions);

// Observe service cards and other elements
document.querySelectorAll('.service-card, .about-text, .contact-content').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(30px)';
  el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  observer.observe(el);
});

// CTA buttons click handlers
document.querySelector('.hero-cta').addEventListener('click', () => {
  document.querySelector('#services').scrollIntoView({
    behavior: 'smooth'
  });
});

// Système de traduction multilingue
const translations = {
  fr: {
    nav_home: 'Accueil',
    nav_services: 'Services',
    nav_about: 'À propos',
    nav_contact: 'Contact',
    hero_title: 'L\'intelligence nouvelle<br />au service de vos<br />solutions digitales',
    hero_subtitle: 'Offrir aux entreprises des solutions technologiques intelligentes et performantes, en alliant <strong>développement</strong> logiciel et <strong>intelligence</strong> artificielle.',
    hero_cta: 'EN SAVOIR PLUS',
    service1_title: 'Agents IA sur mesure',
    service1_description: 'Nous concevons des agents intelligents capables d\'automatiser vos processus métiers les plus complexes. Autonomes, évolutifs et intégrés à votre environnement, ils prennent des décisions et agissent à votre place — en continu.',
    service1_cta1: 'Automatiser mes processus',
    service1_cta2: 'Voir comment ça marche',
    service2_title: 'IA collective & autonome',
    service2_description: 'Plusieurs agents spécialisés qui collaborent, se coordonnent et décident en temps réel. Nous construisons ces écosystèmes sur mesure, de la conception à la mise en production, pour que votre organisation gagne en vitesse et en efficacité.',
    service2_cta1: 'Découvrir nos solutions',
    service2_cta2: 'Parler à un expert',
    service3_title: 'Développement sur mesure',
    service3_description: 'De votre site web à votre application métier, nous développons des solutions digitales pensées pour vos utilisateurs et conçues pour durer. Web, mobile, API ou intégration continue — nous transformons vos idées en produits fiables et évolutifs.',
    service3_cta1: 'Démarrer un projet',
    service3_cta2: 'Voir nos réalisations',
    service4_title: 'Recrutement de talents tech',
    service4_description: 'Nous identifions et positionnons des profils techniques d\'excellence — développeurs backend, frontend, ingénieurs IA, architectes cloud et experts DevOps. Nous accompagnons entreprises et candidats pour créer les meilleurs matchs dans l\'écosystème tech.',
    service4_cta1: 'Obtenir mon diagnostic gratuit',
    service4_cta2: 'En savoir plus',
    about_title: 'À PROPOS',
    about_description: 'Velora Intelligence est un cabinet spécialisé en ingénierie IT et intelligence artificielle, offrant une approche complète combinant recrutement de profils techniques d\'excellence, consulting stratégique en transformation digitale et développement sur-mesure de solutions innovantes. Notre expertise unique nous permet d\'accompagner les entreprises dans leur évolution technologique, de l\'identification des talents jusqu\'à la livraison de systèmes d\'IA avancés et d\'architectures multi-agents performantes.',
    contact_title: 'Contactez-nous',
    contact_description: '<strong>Entreprises :</strong> Vous avez un projet digital, IA ou vous cherchez des talents tech ?<br /><strong>Candidats :</strong> Vous êtes développeur, ingénieur IA ou expert cloud ?<br /><br />Parlons-en — nous vous répondons dans les plus brefs délais.',
    form_name: 'Nom',
    form_email: 'Email',
    form_iam: 'Je suis...',
    form_company: 'Une entreprise (consulting/solutions)',
    form_profile: 'Un profil technique (candidat)',
    form_company_specialty: 'Entreprise / Spécialité',
    form_message: 'Message',
    form_submit: 'Envoyer',
    footer_copyright: '© 2026 Velora Intelligence. Tous droits réservés.'
  },
  en: {
    nav_home: 'Home',
    nav_services: 'Services',
    nav_about: 'About',
    nav_contact: 'Contact',
    hero_title: 'New intelligence<br />at the service of your<br />digital solutions',
    hero_subtitle: 'Offering businesses intelligent and efficient technological solutions, combining software <strong>development</strong> and artificial <strong>intelligence</strong>.',
    hero_cta: 'LEARN MORE',
    service1_title: 'Custom AI Agents',
    service1_description: 'We design intelligent agents capable of automating your most complex business processes. Autonomous, scalable and integrated into your environment, they make decisions and act on your behalf — continuously.',
    service1_cta1: 'Automate my processes',
    service1_cta2: 'See how it works',
    service2_title: 'Collective & autonomous AI',
    service2_description: 'Multiple specialized agents that collaborate, coordinate and decide in real time. We build these ecosystems to measure, from design to production, so your organization gains speed and efficiency.',
    service2_cta1: 'Discover our solutions',
    service2_cta2: 'Talk to an expert',
    service3_title: 'Custom development',
    service3_description: 'From your website to your business application, we develop digital solutions designed for your users and built to last. Web, mobile, API or continuous integration — we turn your ideas into reliable, scalable products.',
    service3_cta1: 'Start a project',
    service3_cta2: 'See our work',
    service4_title: 'Consulting & Strategy',
    service4_title: 'Tech talent recruitment',
    service4_description: 'We identify and place top-tier technical profiles — backend developers, frontend developers, AI engineers, cloud architects and DevOps experts. We connect companies and candidates to create the best matches in the tech ecosystem.',
    service4_cta1: 'Get my free diagnosis',
    service4_cta2: 'Learn more',
    about_title: 'ABOUT',
    about_description: 'Velora Intelligence is a firm specialized in IT engineering and artificial intelligence, offering a comprehensive approach combining recruitment of excellent technical profiles, strategic consulting in digital transformation and custom development of innovative solutions. Our unique expertise allows us to support companies in their technological evolution, from talent identification to the delivery of advanced AI systems and high-performance multi-agent architectures.',
    contact_title: 'Contact us',
    contact_description: '<strong>Companies:</strong> Got a digital or AI project, or looking for tech talent?<br /><strong>Candidates:</strong> Are you a developer, AI engineer or cloud expert?<br /><br />Let\'s talk — we\'ll get back to you as soon as possible.',
    form_name: 'Name',
    form_email: 'Email',
    form_iam: 'I am...',
    form_company: 'A company (consulting/solutions)',
    form_profile: 'A technical profile (candidate)',
    form_company_specialty: 'Company / Specialty',
    form_message: 'Message',
    form_submit: 'Send',
    footer_copyright: '© 2026 Velora Intelligence. All rights reserved.'
  }
};

let currentLang = 'fr';

function translatePage(lang) {
  currentLang = lang;
  
  // Traduire tous les éléments avec data-lang-key
  document.querySelectorAll('[data-lang-key]').forEach(element => {
    const key = element.getAttribute('data-lang-key');
    if (translations[lang] && translations[lang][key]) {
      // Pour les éléments de formulaire, mettre à jour le placeholder
      if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
        element.placeholder = translations[lang][key];
      } else {
        element.innerHTML = translations[lang][key];
      }
    }
  });
  
  // Mettre à jour l'URL avec le segment de langue
  updateURL(lang);
  
  // Mettre à jour les boutons de langue
  document.querySelectorAll('.lang-option').forEach(btn => {
    btn.classList.remove('active');
    if (btn.getAttribute('data-lang') === lang) {
      btn.classList.add('active');
    }
  });
  
  // Mettre à jour le bouton principal avec le drapeau et texte correspondant
  const langToggle = document.querySelector('.lang-toggle');
  const flagIcon = langToggle.querySelector('.flag-icon');
  const langText = langToggle.querySelector('.lang-text');
  
  if (lang === 'fr') {
    flagIcon.textContent = '🇫🇷';
    langText.textContent = 'FR';
  } else {
    flagIcon.textContent = '🇺🇸';
    langText.textContent = 'EN';
  }
  
  // Fermer le dropdown
  document.querySelector('.language-dropdown').classList.remove('open');
  
  // Sauvegarder la langue choisie
  localStorage.setItem('selectedLanguage', lang);
}

// Fonction pour mettre à jour l'URL avec le segment de langue
function updateURL(lang) {
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  const currentHash = window.location.hash;
  
  let newPath;
  
  if (lang === 'en') {
    // Ajouter /en si pas déjà présent
    if (!currentPath.startsWith('/en')) {
      newPath = '/en' + (currentPath === '/' ? '' : currentPath);
    } else {
      newPath = currentPath;
    }
  } else {
    // Supprimer /en pour le français (langue par défaut)
    if (currentPath.startsWith('/en')) {
      newPath = currentPath.substring(3) || '/';
    } else {
      newPath = currentPath;
    }
  }
  
  const newURL = newPath + currentSearch + currentHash;
  
  // Mettre à jour l'URL sans recharger la page
  if (newURL !== window.location.pathname + currentSearch + currentHash) {
    history.pushState({ lang }, '', newURL);
  }
}

// Fonction pour détecter la langue depuis l'URL
function detectLanguageFromURL() {
  const path = window.location.pathname;
  if (path.startsWith('/en')) {
    return 'en';
  }
  return 'fr';
}

// Initialiser le système de langue
document.addEventListener('DOMContentLoaded', () => {
  // Détecter la langue depuis l'URL d'abord, puis localStorage, puis français par défaut
  const urlLang = detectLanguageFromURL();
  const savedLang = localStorage.getItem('selectedLanguage');
  const defaultLang = urlLang || savedLang || 'fr';
  translatePage(defaultLang);
  
  // Gérer tous les dropdowns de langue (desktop et mobile)
  const langToggles = document.querySelectorAll('.lang-toggle');
  const langDropdowns = document.querySelectorAll('.language-dropdown');
  
  langToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const dropdown = toggle.closest('.language-dropdown');
      dropdown.classList.toggle('open');
      
      // Fermer les autres dropdowns
      langDropdowns.forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('open');
        }
      });
    });
  });
  
  // Fermer tous les dropdowns en cliquant ailleurs
  document.addEventListener('click', () => {
    langDropdowns.forEach(dropdown => {
      dropdown.classList.remove('open');
    });
  });
  
  // Ajouter les événements aux options de langue (desktop et mobile)
  document.querySelectorAll('.lang-option').forEach(btn => {
    btn.addEventListener('click', () => {
      const lang = btn.getAttribute('data-lang');
      translatePage(lang);
    });
  });
  
  // Gérer les changements d'URL (bouton retour du navigateur)
  window.addEventListener('popstate', (event) => {
    const lang = detectLanguageFromURL();
    translatePage(lang);
  });
  
  // Gérer le menu burger mobile
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-menu .nav-link');
  
  if (mobileMenuToggle && mobileMenuOverlay) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenuToggle.classList.toggle('active');
      mobileMenuOverlay.classList.toggle('active');
      
      // Empêcher le scroll du body quand le menu est ouvert
      if (mobileMenuOverlay.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
    
    // Fermer le menu quand on clique sur un lien
    mobileNavLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileMenuToggle.classList.remove('active');
        mobileMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
    
    // Fermer le menu en cliquant sur l'overlay
    mobileMenuOverlay.addEventListener('click', (e) => {
      if (e.target === mobileMenuOverlay) {
        mobileMenuToggle.classList.remove('active');
        mobileMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
});

console.log('Velora Intelligence site loaded successfully!');
